import React, { useState, useCallback } from "react";
import emailjs from "@emailjs/browser";
import "../../styles/contact.css";
import background from "../assets/images/backgroundContact.jpeg";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSuccessMessage("");
    setErrorMessage("");

    try {
      // Hardcoded EmailJS credentials
      const serviceID = "service_bd3wajn";
      const templateID = "template_4349bjg";
      const publicKey = "sjM4xTYWvmDp4bBO8";

      const response = await emailjs.send(
        serviceID,
        templateID,
        {
          from_name: formData.name,
          from_email: formData.email,
          message: formData.message,
        },
        publicKey
      );

      if (response.status === 200) {
        setSuccessMessage("Your message has been sent successfully!");
        setFormData({ name: "", email: "", message: "" });
      } else {
        throw new Error("Failed to send email");
      }
    } catch (error) {
      console.error("Submission error:", error);
      setErrorMessage("Failed to send message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div
      className="contact-container"
      style={{
        backgroundImage: `url(${background})`,
        backgroundSize: "cover",
        backgroundPosition: "center 10%",
        backgroundRepeat: "no-repeat",
        backgroundColor: "#f5f5f5",
        paddingTop: "150px", // Adjusted to ensure form is below navbar
      }}
    >
      <div className="contact-content">
        <div className="contact-header">
          <h1>Contact Us</h1>
          <p>Get in touch with us for any questions or inquiries</p>
          <p className="encouragement-message">Reach out for anything at all!</p>
        </div>

        <form onSubmit={handleSubmit} className="contact-form">
          {successMessage && (
            <div className="success-message">{successMessage}</div>
          )}
          {errorMessage && <div className="error-message">{errorMessage}</div>}

          <div className="form-group">
            <label htmlFor="name">Name:</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="Your Name"
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Email:</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="Your Email"
              className="form-control"
            />
          </div>

          <div className="form-group">
            <label htmlFor="message">Message:</label>
            <textarea
              id="message"
              name="message"
              value={formData.message}
              onChange={handleChange}
              required
              placeholder="Your Message"
              className="form-control"
              rows="5"
            />
          </div>

          <button
            type="submit"
            className="submit-button"
            disabled={isSubmitting}
          >
            {isSubmitting ? "Sending..." : "Send Message"}
          </button>
        </form>

        <div className="contact-info">
          <div className="info-item">
            <i className="bi bi-envelope"></i>
            <p>corwin@coleesoftwareservices.com</p>
          </div>
          <div className="info-item">
            <i className="bi bi-telephone"></i>
            <p>971-267-9344</p>
          </div>
          <div className="info-item">
            <i className="bi bi-geo-alt"></i>
            <p>McMinnville, OR</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
